function createScript(src) {
    return new Promise(resolve => {
        const script = document.createElement("script");
        script.setAttribute("async", "async");
        script.onload = resolve;
        script.setAttribute("src", src);
        document.head.appendChild(script);
    });
}

function loadScript(...urls) {
    return Promise.all(urls.map(createScript));
}

export default loadScript;